import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { TemplateSixteenSection } from "./common/sections";

export const Summary = ({
  heading,
  summary,
  themeColor,
}: {
  heading: string;
  summary: string;
  themeColor: string;
}) => {
  return (
    <TemplateSixteenSection themeColor={themeColor} heading={heading}>
      <View>
        {summary && <ResumePDFText themeColor="black">{summary}</ResumePDFText>}
      </View>
    </TemplateSixteenSection>
  );
};
